"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Logo } from "@/components/logo";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import React from "react";
import { cn } from "@/lib/utils";
import { ThemeToggle } from "./theme-toggle";
const menuItems = [{
  name: "Agents",
  href: "/agents"
}, {
  name: "Pricing",
  href: "/pricing"
}, {
  name: "About",
  href: "#link"
}];
export const HeroHeader = () => {
  const $ = _c(43);
  const [menuState, setMenuState] = React.useState(false);
  const [isScrolled, setIsScrolled] = React.useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 50);
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  React.useEffect(t0, t1);
  const t2 = menuState && "active";
  const t3 = isScrolled && "bg-background/50 max-w-4xl rounded-2xl border backdrop-blur-lg lg:px-5";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("mx-auto mt-2 max-w-6xl px-6 transition-all duration-300 lg:px-12", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Link href="/" aria-label="home" className="flex items-center space-x-2"><Logo /></Link>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== menuState) {
    t6 = () => setMenuState(!menuState);
    $[5] = menuState;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = menuState == true ? "Close Menu" : "Open Menu";
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Menu className="in-data-[state=active]:rotate-180 in-data-[state=active]:scale-0 in-data-[state=active]:opacity-0 m-auto size-6 duration-200" />;
    t9 = <X className="in-data-[state=active]:rotate-0 in-data-[state=active]:scale-100 in-data-[state=active]:opacity-100 absolute inset-0 m-auto size-6 -rotate-180 scale-0 opacity-0 duration-200" />;
    $[7] = t8;
    $[8] = t9;
  } else {
    t8 = $[7];
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t6 || $[10] !== t7) {
    t10 = <div className="flex w-full justify-between lg:w-auto">{t5}<button onClick={t6} aria-label={t7} className="relative z-20 -m-2.5 -mr-4 block cursor-pointer p-2.5 lg:hidden">{t8}{t9}</button></div>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="absolute inset-0 m-auto hidden size-fit lg:block"><ul className="flex gap-8 text-sm">{menuItems.map(_temp)}</ul></div>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="lg:hidden"><ul className="space-y-6 text-base">{menuItems.map(_temp2)}</ul></div>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = isScrolled && "lg:hidden";
  let t14;
  if ($[14] !== t13) {
    t14 = cn(t13);
    $[14] = t13;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Link href="/auth/signin"><span>Login</span></Link>;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== t14) {
    t16 = <Button asChild={true} variant="outline" size="sm" className={t14}>{t15}</Button>;
    $[17] = t14;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  const t17 = isScrolled && "lg:hidden";
  let t18;
  if ($[19] !== t17) {
    t18 = cn(t17);
    $[19] = t17;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Link href="/auth/signup"><span>Sign Up</span></Link>;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  let t20;
  if ($[22] !== t18) {
    t20 = <Button asChild={true} size="sm" className={t18}>{t19}</Button>;
    $[22] = t18;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  const t21 = isScrolled ? "lg:inline-flex" : "hidden";
  let t22;
  if ($[24] !== t21) {
    t22 = cn(t21);
    $[24] = t21;
    $[25] = t22;
  } else {
    t22 = $[25];
  }
  let t23;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Link href="#"><span>Get Started</span></Link>;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  let t24;
  if ($[27] !== t22) {
    t24 = <Button asChild={true} size="sm" className={t22}>{t23}</Button>;
    $[27] = t22;
    $[28] = t24;
  } else {
    t24 = $[28];
  }
  let t25;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <ThemeToggle />;
    $[29] = t25;
  } else {
    t25 = $[29];
  }
  let t26;
  if ($[30] !== t16 || $[31] !== t20 || $[32] !== t24) {
    t26 = <div className="bg-background in-data-[state=active]:block lg:in-data-[state=active]:flex mb-6 hidden w-full flex-wrap items-center justify-end space-y-8 rounded-3xl border p-6 shadow-2xl shadow-zinc-300/20 md:flex-nowrap lg:m-0 lg:flex lg:w-fit lg:gap-6 lg:space-y-0 lg:border-transparent lg:bg-transparent lg:p-0 lg:shadow-none dark:shadow-none dark:lg:bg-transparent">{t12}<div className="flex w-full flex-col space-y-3 sm:flex-row sm:gap-3 sm:space-y-0 md:w-fit">{t16}{t20}{t24}{t25}</div></div>;
    $[30] = t16;
    $[31] = t20;
    $[32] = t24;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  let t27;
  if ($[34] !== t10 || $[35] !== t26) {
    t27 = <div className="relative flex flex-wrap items-center justify-between gap-6 py-3 lg:gap-0 lg:py-4">{t10}{t11}{t26}</div>;
    $[34] = t10;
    $[35] = t26;
    $[36] = t27;
  } else {
    t27 = $[36];
  }
  let t28;
  if ($[37] !== t27 || $[38] !== t4) {
    t28 = <div className={t4}>{t27}</div>;
    $[37] = t27;
    $[38] = t4;
    $[39] = t28;
  } else {
    t28 = $[39];
  }
  let t29;
  if ($[40] !== t2 || $[41] !== t28) {
    t29 = <header><nav data-state={t2} className="fixed z-30 w-full px-2">{t28}</nav></header>;
    $[40] = t2;
    $[41] = t28;
    $[42] = t29;
  } else {
    t29 = $[42];
  }
  return t29;
};
function _temp(item, index) {
  return <li key={index}><Link href={item.href} className="text-muted-foreground hover:text-accent-foreground block duration-150"><span>{item.name}</span></Link></li>;
}
function _temp2(item_0, index_0) {
  return <li key={index_0}><Link href={item_0.href} className="text-muted-foreground hover:text-accent-foreground block duration-150"><span>{item_0.name}</span></Link></li>;
}